// extracted by mini-css-extract-plugin
module.exports = {"container":"TestComponent_container__131-s"};